// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"57ffecf8","703":"54b2922c"}[chunkId] + ".chunk.js";
};